<div class="worker-file-verification-page">
  <div *ngIf="!isLoading && !details" class="not-found">
    <p>{{ 'FileNotFound' | translate }}</p>
  </div>

  <div *ngIf="!isLoading && details" class="verification-card mat-elevation-z2">
    <h2>{{ 'WorkerFileVerification' | translate }}</h2>

    <mat-card class="info-card">
      <mat-card-content>
        <div class="info-row">
          <span class="label">{{ 'WorkerFileVerificationFileId' | translate }}:</span>
          <span class="value">{{ details.FileId }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ 'WorkerFileVerificationFileName' | translate }}:</span>
          <span class="value">{{ details.FileName }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ 'WorkerFileVerificationFileType' | translate }}:</span>
          <span class="value">{{ details.FileTypeName }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ 'WorkerFileVerificationWorkerName' | translate }}:</span>
          <span class="value">{{ details.WorkerFullName }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ 'WorkerFileVerificationWorkerEmail' | translate }}:</span>
          <span class="value">{{ details.WorkerEmail }}</span>
        </div>
        <div class="info-row">
          <span class="label">{{ 'WorkerFileVerificationStatus' | translate }}:</span>
          <span
            class="value status-badge"
            [class.status-pending]="details.VerificationStatusId === statusEnum.Pending"
            [class.status-approved]="details.VerificationStatusId === statusEnum.Approved"
            [class.status-rejected]="details.VerificationStatusId === statusEnum.Rejected"
          >
            <span *ngIf="details.VerificationStatusId === statusEnum.Pending">{{ 'WorkerFileVerificationStatusPending' | translate }}</span>
            <span *ngIf="details.VerificationStatusId === statusEnum.Approved">{{ 'WorkerFileVerificationStatusApproved' | translate }}</span>
            <span *ngIf="details.VerificationStatusId === statusEnum.Rejected">{{ 'WorkerFileVerificationStatusRejected' | translate }}</span>
          </span>
        </div>
        <div class="info-row" *ngIf="details.RejectionReason">
          <span class="label">{{ 'WorkerFileVerificationRejectionReason' | translate }}:</span>
          <span class="value">{{ details.RejectionReason }}</span>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="actions-section" *ngIf="details.VerificationStatusId === statusEnum.Pending">
      <mat-card class="action-card">
        <mat-card-header>
          <mat-card-title>{{ 'WorkerFileVerificationApprove' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="approveForm" (ngSubmit)="approve()">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ 'WorkerFileVerificationSelectInstitution' | translate }}</mat-label>
              <mat-select formControlName="institutionId">
                <mat-option *ngFor="let inst of details.Institutions" [value]="inst.Id">
                  {{ inst.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-raised-button color="primary" type="submit" [disabled]="approveForm.invalid || actionLoading">
              {{ 'WorkerFileVerificationApprove' | translate }}
            </button>
          </form>
        </mat-card-content>
      </mat-card>

      <mat-card class="action-card">
        <mat-card-header>
          <mat-card-title>{{ 'WorkerFileVerificationReject' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="rejectForm" (ngSubmit)="reject()">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ 'WorkerFileVerificationRejectionReason' | translate }}</mat-label>
              <textarea matInput formControlName="reason" rows="3"></textarea>
            </mat-form-field>
            <button mat-raised-button color="warn" type="submit" [disabled]="rejectForm.invalid || actionLoading">
              {{ 'WorkerFileVerificationReject' | translate }}
            </button>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
